import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PrivacyPage() {
  return (
    <>
      <Navbar />
      <main className="bg-white min-h-screen">
        <section className="relative bg-[#0f1628] geo-pattern pt-32 pb-20">
          <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
            <span className="font-cormorant text-[#c9a84c] text-sm tracking-[0.4em] uppercase block mb-3">Privacy Policy</span>
            <h1 className="font-serif-jp text-white text-4xl md:text-5xl tracking-wider font-medium mb-4">プライバシーポリシー</h1>
            <div className="flex items-center gap-3"><div className="w-12 h-px bg-[#c9a84c]"></div><div className="w-1.5 h-1.5 bg-[#c9a84c] rotate-45"></div></div>
          </div>
        </section>

        <section className="py-20 md:py-28">
          <div className="max-w-3xl mx-auto px-6 md:px-10">
            <p className="text-[#0f1628]/60 text-sm font-sans leading-relaxed mb-10">
              合同会社ＡＺ（以下「当社」）は、お客様の個人情報の保護を重要な責務と認識し、以下のとおりプライバシーポリシーを定めます。
            </p>

            {[
              {
                title: '第1条（個人情報の定義）',
                body: '本ポリシーにおける「個人情報」とは、個人情報保護法に定める個人情報、すなわち生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるものをいいます。',
              },
              {
                title: '第2条（個人情報の収集）',
                body: '当社は、お問い合わせフォーム、電話、メール等を通じて、お名前、会社名、メールアドレス、電話番号等の個人情報を収集することがあります。収集にあたっては、利用目的を明示した上で、適法かつ公正な手段により行います。',
              },
              {
                title: '第3条（個人情報の利用目的）',
                body: '当社が収集した個人情報は、以下の目的のために利用いたします。\n・お問い合わせへの回答および対応\n・サービスのご提供および業務遂行\n・各種ご連絡・情報提供\n・法令に基づく対応',
              },
              {
                title: '第4条（個人情報の第三者提供）',
                body: '当社は、以下の場合を除き、お客様の個人情報を第三者に提供いたしません。\n・お客様の同意がある場合\n・法令に基づく場合\n・人の生命、身体または財産の保護のために必要がある場合',
              },
              {
                title: '第5条（個人情報の管理）',
                body: '当社は、個人情報の漏洩、滅失またはき損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。また、個人情報を取り扱う従業者に対して、必要かつ適切な監督を行います。',
              },
              {
                title: '第6条（個人情報の開示・訂正・削除）',
                body: 'お客様は、当社が保有するご自身の個人情報について、開示・訂正・削除を請求することができます。ご請求の際は、下記お問い合わせ先までご連絡ください。',
              },
              {
                title: '第7条（Cookieの使用）',
                body: '当社ウェブサイトでは、サービス向上のためCookieを使用する場合があります。ブラウザの設定によりCookieを無効にすることができますが、一部機能が利用できなくなる場合があります。',
              },
              {
                title: '第8条（プライバシーポリシーの変更）',
                body: '当社は、必要に応じて本ポリシーを変更することがあります。変更後のポリシーは、当ウェブサイトに掲載した時点から効力を生じるものとします。',
              },
              {
                title: '第9条（お問い合わせ）',
                body: '個人情報の取り扱いに関するお問い合わせは、下記までご連絡ください。\n\n合同会社ＡＺ\n代表者：藁科光\n所在地：埼玉県三郷市高州３丁目１６４番地バンブーハイツ１０７\nメール：administrator@az-consulting-llc.com\n電話：090-6340-5373',
              },
            ].map((section) => (
              <div key={section.title} className="mb-10 border-l-2 border-[#c9a84c]/30 pl-6">
                <h2 className="font-serif-jp text-[#0f1628] text-base tracking-wider font-medium mb-3">{section.title}</h2>
                <p className="text-[#0f1628]/60 text-sm font-sans leading-relaxed whitespace-pre-line">{section.body}</p>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
